<template>
    <v-row class="center">
        <v-col cols="11">
            <v-card style="position: relative;">
                <v-stepper v-model="formStepper">
                    <v-stepper-header>
                        <v-stepper-step
                            complete-icon="fas fa-check"
                            edit-icon="fas fa-check"
                            :editable="formStepper >= 1"
                            :complete="formStepper >= 1"
                            step="1"
                        >
                            Event Info
                        </v-stepper-step>
                        <v-stepper-step
                            complete-icon="fas fa-check"
                            edit-icon="fas fa-check"
                            :editable="formStepper > 2"
                            :complete="formStepper > 2"
                            step="2"
                        >
                            Bussinesses
                        </v-stepper-step>
                        <v-stepper-step
                            complete-icon="fas fa-check"
                            edit-icon="fas fa-check"
                            :editable="formStepper > 3"
                            :complete="formStepper > 3"
                            step="3"
                        >
                            Interest Tags
                        </v-stepper-step>
                        <v-stepper-step complete-icon="fas fa-check" edit-icon="fas fa-check" step="4">
                            Event Photos
                        </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-content step="1">
                        <h2>Event Info</h2>
                        <v-form
                            ref="page1RequiredForm"
                            style="width: 100%; height: 100%;"
                            v-model="page1Validator"
                            lazy-validation
                        >
                            <v-row class="center">
                                <v-col :cols="hasDates ? 4 : 5">
                                    <v-text-field
                                        outlined
                                        label="Event Name"
                                        :rules="[v => !!v || 'Event Name is required']"
                                        v-model="eventName"
                                    ></v-text-field>
                                </v-col>
                                <v-col :cols="hasDates ? 4 : 5">
                                    <v-menu
                                        ref="dateMenu"
                                        v-model="startDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="dateRangeText"
                                                readonly
                                                outlined
                                                label="Event Dates"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker no-title range @input="timeCheck" :min="today" v-model="computedDates">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="startDateMenu = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text color="primary" @click="computedDates = []">
                                                Clear
                                            </v-btn>
                                            <v-btn text color="primary" @click="$refs.dateMenu.save(computedDates)">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col v-if="hasDates" cols="3">
                                    <vue-timepicker @change="setCloseFloor" ref="opens" close-on-complete v-model="startTime" input-class="time-picker-input mb-3" placeholder="Starts" 
                                        class="picker-container left-dropdown" :minute-interval="30" format="hh:mm A">
                                        <template v-slot:clearButton>
                                            <div><v-icon>fas fa-times</v-icon></div>
                                        </template>
                                    </vue-timepicker>
                                    <vue-timepicker ref="closes" close-on-complete v-model="endTime" input-class="time-picker-input" placeholder="Ends" 
                                        class="picker-container left-dropdown" :minute-interval="30" format="hh:mm A">
                                        <template v-slot:clearButton>
                                            <div><v-icon>fas fa-times</v-icon></div>
                                        </template>
                                    </vue-timepicker>
                                </v-col>
                            </v-row>
                            <v-row class="center">
                                <v-col cols="8">
                                    <V-textarea label="Description" outlined v-model="description"></V-textarea>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <h2>Include Event Partners</h2>
                        <v-row class="center">
                            <v-col cols="6">
                                <v-autocomplete
                                    v-model="selected"
                                    @change="clearSearchTest"
                                    :search-input.sync="businessName"
                                    :items="[...businessList, ...selected]"
                                    :rules="selectedBusinessRules"
                                    item-text="locationName"
                                    item-value="_id"
                                    multiple
                                    hide-no-data
                                    hide-selected
                                    label="Business Name"
                                    prepend-icon="mdi-database-search"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <v-row>
                            <v-col class="center" cols="9">
                                <v-chip-group
                                    v-model="customerSearchTags"
                                    multiple
                                    column
                                    active-class="primary--text"
                                >
                                    <v-chip v-for="tag in customerTags" :key="tag" :value="tag">
                                        {{ tag }}
                                    </v-chip>
                                </v-chip-group>
                            </v-col>
                        </v-row>
                        <v-row v-if="page3Validator">
                            <v-col class="center" cols="9">
                                Please select at least 1 interest tag
                            </v-col>
                        </v-row>
                    </v-stepper-content>
                    <v-stepper-content step="4">
                        <v-row>
                            <v-col class="center" cols="9">
                                <v-row>
                                    <image-card
                                        v-for="(photo, index) in eventPhotos"
                                        @remove-business-photo="removeEventPhoto"
                                        @update-photo="updateEventPhoto"
                                        :index="index"
                                        :photo="photo.photoData"
                                        :key="index"
                                    ></image-card>
                                    <image-card
                                        @remove-business-photo="removeEventPhoto"
                                        @add-photo="addEventPhotos"
                                        :photo="addImagePlaceholder"
                                    ></image-card>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-stepper-content>
                </v-stepper>
                <v-row>
                    <v-col v-if="formStepper > 1" class="center">
                        <v-btn @click="formStepper--" class="whitespace-margin" block>Back</v-btn>
                    </v-col>
                    <v-col v-if="formStepper === 4" class="center">
                        <v-btn @click="submitEventInfo" class="whitespace-margin" block>Submit</v-btn>
                    </v-col>
                    <v-col v-else-if="formStepper < 4" class="center">
                        <v-btn @click="incrementStepper" class="whitespace-margin" block>Continue</v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<style lang="scss">
.picker-container {
    margin-bottom: auto;
}
</style>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
import moment from 'moment'
import { MongoMixins } from '../../mixins/mongo-mixins'
import LocationTypeEnums from '../../assets/Enums/LocationTypeEnums'
import ImageCard from '../../components/common/ImageCard'
import FileType from '../../assets/Enums/FileType'

export default {
    name: 'business-search-edit',
    mixins: [MongoMixins],
    components: {
        'image-card': ImageCard,
        VueTimepicker
    },
    data: () => ({
        formStepper: 1,
        page1Validator: false,
        page3Validator: false,
        startDateMenu: false,
        startTimeMenu: false,
        endTimeMenu: false,
        businessName: null,
        customerSearchTags: [],
        businessList: [],
        selected: [],
        eventName: null,
        description: null,
        eventPhotos: [],
        dates: [],
        closeRange: [],
        startTime: '',
        endTime: '', // default to midnight of startTime if single date
        hoursRange: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
            11, 12, 13, 14, 15, 16, 17, 18, 
            19, 20, 21, 22, 23, 24
        ]
    }),
    methods: {
        setCloseFloor(time) {
            const floor = parseInt(time.data.HH)
            this.closeRange = this.hoursRange.filter(h => floor < h);
        },
        timeCheck(){
            if(this.endTime < this.startTime && !this.isMultiDate) {
                this.endTime = null;
            }
        },
        clearSearchTest() {
            this.businessName = ''
        },
        incrementStepper() {
            if (this.formStepper === 1 && this.$refs.page1RequiredForm.validate()) {
                this.formStepper++
            } else if (this.formStepper === 2) {
                this.formStepper++
            } else if (this.formStepper === 3) {
                if (this.customerSearchTags.length > 0) {
                    this.formStepper++
                } else {
                    this.page3Validator = true
                    setTimeout(() => {
                        this.page3Validator = false
                    }, 3000)
                }
            }
        },
        updateEventPhoto(updatePhotoObj) {
            console.log(updatePhotoObj.photoFile.name)
            const reader = new FileReader()
            reader.onload = event => {
                this.$set(this.eventPhotos, updatePhotoObj.photoIndex, {
                    photoData: event.target.result,
                    photoFile: updatePhotoObj.photoFile,
                    type: FileType.EVENT
                })
            }
            reader.readAsDataURL(updatePhotoObj.photoData)
        },
        removeEventPhoto(index) {
            this.eventPhotos.splice(index, 1)
        },
        addEventPhotos(files) {
            if (this.eventPhotos.length + 1 < 10) {
                for (let i = 0; i < files.length; i++) {
                    const item = files[i]
                    const reader = new FileReader()

                    console.log('add photo: ' + item.name)
                    reader.onload = event => {
                        this.eventPhotos.push({
                            photoData: event.target.result,
                            photoFile: item,
                            type: FileType.EVENT
                        })
                    }
                    reader.readAsDataURL(item)
                }
            } else {
                alert('maximum photos chosen')
            }
        },
        submitEventInfo() {
            const data = JSON.parse(JSON.stringify(this.$data))
            //submit event info via mixin function
            delete data.page1Validator
            delete data.page3Validator
            delete data.formStepper
            delete data.startDateMenu
            delete data.startTimeMenu
            delete data.endTimeMenu
            delete data.businessList
            delete data.businessName
            delete data.eventPhotos
            delete data.closeRange
            delete data.hoursRange

            console.log('DATA: ' + JSON.stringify(data))
            this.submitEventRequest(data)
                .then(data => {
                    console.log('IMAGES: ' + data.data.id);
                    this.submitPhotos(data.data.id, this.eventPhotos, FileType.EVENT);
                    this.resetEventInfo();
                })
                .catch(e => {
                    console.log('submit error: ' + e)
                })
        },
        resetEventInfo() {
            this.formStepper = 1
            this.page1Validator = false
            this.page2Validator = false
            this.page3Validator = false
            this.startDateMenu = false
            this.startTimeMenu = false
            this.endTimeMenu = false
            this.businessName = null
            this.customerSearchTags = []
            this.businessList = []
            this.selected = []
            this.eventName = null
            this.description = null
            this.eventPhotos = []
            this.dates = []
            this.startTime = '';
            this.endTime = '';
        },
    },
    watch: {
        businessName(val) {
            console.log('business search')
            if (!!val && val.length >= 3 && val.length % 3 === 1) {
                const geoHashGroup = this.$store.getters.geoHashGroup;
                const partnerId = this.$store.state.partnerData._id;
                console.log('searchForBus: ' + val)
                this.searchForLocation(val, [LocationTypeEnums.BUSINESS], geoHashGroup)
                    .then(result => {
                        this.businessList = result.data
                        .filter(s => s._id !== partnerId)
                        .map(item => {
                            item.locationName = `${item.partnerName} (${item.businessAddress.city})`;
                            return item;
                        });
                    })
                    .catch(e => {
                        console.log('SEARCH CATCH ERROR: ' + JSON.stringify(e))
                    })
            }
        },
    },
    computed: {
        isMultiDate() {
            return this.dates.length > 1
        },
        computedDates: {
            set(val) {
                this.dates = [...val].sort((a, b) => {
                    return new Date(a) - new Date(b)
                })
            },
            get() {
                return this.dates
            },
        },
        hasDates() {
            return !!this.dates.length;
        },
        today(){
            return new Date().toISOString().substring(0,10);
        },
        customerTags() {
            return require('../../assets/Entities/customerTags').default
        },
        dateRangeText() {
            return this.dates.join(' ~ ')
        },
        endTimeTextDisplay() {
            return this.endTime ? moment(this.endTime, ['HH.mm']).format('hh:mm a') : '';
        },
        startTimeTextDisplay() {
            return this.startTime ? moment(this.startTime, ['HH.mm']).format('hh:mm a') : '';
        },
        addImagePlaceholder() {
            return require('../../assets/Add-Image-Placeholder.svg')
        },
        selectedBusinessRules() {
            return [v => v.length <= 7 || 'Too many companies selected.']
        },
    },
}
</script>
